export enum eLivraisonHistorySourceType {
    Auto = 0,
    Nat_pro = 1,
    SAC = 2,
    TPSLRoute = 3
 }
 

 